<template>
  <div class="checkTab" style="height:100%">
    <header>
      <el-tooltip effect="dark" content="返回" placement="bottom">
        <button @click="backtrack" style="cursor:pointer" class="returnBtn">
          <i class="el-icon-back"></i>
        </button>
      </el-tooltip>

      <!-- <span> 返回</span> -->
      <div>{{checkTxt}}详情</div>
    </header>
    <div class="main_box">
      <h3>名称：{{rowName}}</h3>
      <div class="topBox">
        <!-- <input type="text" v-model="search"/> -->
        <!-- <button class="search" @click="search">搜索</button> -->
        <input type="text" v-model="search" placeholder="输入名称" @keyup.enter="seek" />
        <i style=" cursor: pointer" class="search el-icon-search" @click="seek"></i>
        <!-- <span>总条目数：{{totalRows}}</span> -->
        <div class="topBox_btn_wrap">
          <button class="themeGoBut" @click="getMesBox">添加</button>
          <button class="themeCallBut" @click="toggleBox">删除</button>
        </div>
      </div>
      <template>
        <div style="overflow: auto;height:calc(100% - 120px)">
          <el-table ref="multipleTable" :data="tableData"
            :header-cell-style="{background:'#EAEAEA',color:'#  454545',padding:'6.5px 0'}" tooltip-effect="dark"
            style="width:100%" border @selection-change="handleSelectionChange" v-loading="loading" :resizable="false"
            @header-dragend="handleDrag" :highlight-current-row="true">
            <template slot="empty">
              <div id="notDate">
                <img src="../../assets/imgs/memory/no_data.png" alt />
                <p>暂无数据，快去创建吧</p>
              </div>
            </template>
            <el-table-column :resizable="false" type="selection" width="60"></el-table-column>
            <el-table-column :resizable="false" type="index" label="序号" width="80"></el-table-column>
            <el-table-column :resizable="false" prop="sourceSent" :label="sourceSent" width>
              <template slot-scope="scope">
                <div contenteditable="true" @focus="changeVerify($event)"
                  @blur="changeUpdate(scope.$index, scope.row,$event,0)" v-html="scope.row.sourceSent"></div>
              </template>
            </el-table-column>
            <el-table-column :resizable="false" prop="targetSent" :label="targetSent" width>
              <template slot-scope="scope">
                <div contenteditable="true" @focus="changeVerify($event)"
                  @blur="changeUpdate(scope.$index, scope.row,$event,1)" v-html="scope.row.targetSent"></div>
              </template>
            </el-table-column>
            <!-- <el-table-column width="120">
            <template slot-scope="scope">
              <button :class="qq(scope.row)" @click="qwe(scope.row)">保存</button>
            </template>
          </el-table-column>-->
          </el-table>
        </div>
      </template>
      <el-pagination class="page" background layout="total,prev, pager, next" :page-size="20" :total="totalRows"
        prev-text="上一页" next-text="下一页" :current-page.sync="currentPage" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <div class="downloadBox" v-show="isShow">
      <h5>
        {{downloadBoxTit}}
        <span @click="getMesShow">
          <img src="../../assets/imgs/message/close_normal.png" alt />
        </span>
      </h5>
      <div class="main" v-show="!isDel ? true :false">
        <div class>
          <p>原文</p>
          <textarea class="txt" v-model="topText"></textarea>
        </div>
        <div class>
          <p>译文</p>
          <textarea class="txt" v-model="botText"></textarea>
        </div>
      </div>
      <div v-show="isDel ? true :false" class="mainText">确认删除选中的{{checkTxt}}条目？</div>
      <div class="but">
        <button class="themeCallBut" @click="call">取消</button>
        <button class="themeGoBut" ref="delEnsureBtn" @click="confirm">确定</button>
      </div>
    </div>
    <div class="hide" v-show="isShow"></div>
  </div>
</template>

<script>
import { setTimeout } from "timers";

export default {
  name: "checkTab",
  beforeRouteEnter (to, from, next) {
    // console.log(to.params.checkTxt == "术语库");
    // console.log(document.getElementsByClassName("memorySon"));
    if (from.path != "/") {
      // 如果不是刷新则赋值1
      sessionStorage.removeItem("myCurrentPage");
    }
    // if (to.query.checkTxt == "术语库") {
    //   setTimeout(() => {
    //     document.getElementById("termBank").parentNode.classList.add("current");
    //   }, 20);

    // } else (to.query.checkTxt == "记忆库") {
    //   setTimeout(() => {
    //     document
    //       .getElementById("memoryBank")
    //       .parentNode.classList.add("current");
    //   }, 20);
    // }
    next();
  },
  // beforeRouteUpdate(to, from, next) {
  //   // 在当前路由改变，但是该组件被复用时调用
  //   // 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候，
  //   // 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
  //   // 可以访问组件实例 `this`
  // },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    // console.log(next);
    // console.log(from);
    if (from.query.checkTxt == "记忆库") {
      document
        .getElementById("memoryBank")
        .parentNode.classList.remove("current");
    }
    if (from.query.checkTxt == "术语库") {
      document
        .getElementById("termBank")
        .parentNode.classList.remove("current");
    }
    next();
  },
  data () {
    return {
      tableData: [],
      multipleSelection: [], // 存储选中的数组
      butClass: "",
      isShow: false,
      downloadBoxTit: "",
      topText: "",
      botText: "",
      isDel: false,
      rowName: "",
      search: "",
      checkTxt: "",
      rowId: "",
      checkPageUrl: "",
      checkAddUrl: "",
      checkDelUrl: "",
      totalRows: 0, // 分页数据总数
      loading: true,
      sentCount: "",
      sourceSent: "",
      targetSent: "",
      updateText: ""
    };
  },
  watch: {
    isShow: {
      immediate: false,
      handler: function () {
        this.selfShow = this.isShow;
        if (this.isShow) {
          this.$refs.delEnsureBtn.focus();
          document.addEventListener("keyup", this.keyUp);
        } else {
          document.removeEventListener("keyup", this.keyUp);
        }
      }
    }
  },
  components: {},
  updated () { },
  created () {
    let params = JSON.parse(this.$Base64.decode(this.$route.query.key));
    // console.log(this.$route.query.rowName, "////////////");
    this.rowName = params.rowName;
    this.checkTxt = params.checkTxt;
    this.rowId = params.rowId;
    // this.sentCount = params.sentCount;
    var reg = /([\u4e00-\u9fa5]{1,10})>([\u4e00-\u9fa5]{1,10})/;
    var langDesc = reg.exec(params.langDesc);
    this.sourceSent = langDesc[1];
    this.targetSent = langDesc[2];
    if (this.checkTxt === "记忆库") {
      this.checkPageUrl = "/api/v1/memorySent/queryPage";
      this.checkAddUrl = "/api/v1/memorySent/addSent";
      this.checkDelUrl = "/api/v1/memorySent/batchDeleteByIdList";
      this.checkUpdate = "/api/v1/memorySent/update";
    } else {
      this.checkPageUrl = "/api/v1/termSent/queryPage";
      this.checkAddUrl = "/api/v1/termSent/addSent";
      this.checkDelUrl = "/api/v1/termSent/batchDeleteByIdList";
      this.checkUpdate = "/api/v1/termSent/update";
    }
    this.currentPage = Number(sessionStorage.getItem("myCurrentPage")) || 1;
    this.queryPage(this.currentPage);
    // this.befCurrentClass()
  },
  beforeDestroy () {
  },
  methods: {
    handleDrag (newWidth, oldWidth, column, event) {
      console.log(newWidth)
      console.log(oldWidth)
      console.log(column)
      console.log(event)
    },
    // befCurrentClass() {
    //   console.log(this.checkTxt)
    //   if (this.checkTxt == "术语库") {
    //     setTimeout(() => {
    //       document.getElementById("termBank").parentNode.classList.add("current");
    //     }, 20);

    //   } else if (this.checkTxt == "记忆库") {
    //     setTimeout(() => {
    //       document
    //         .getElementById("memoryBank")
    //         .parentNode.classList.add("current");
    //     }, 20);
    //   }
    // },
    keyUp (event) {
      //确定
      if (event.keyCode === 13) {
        this.confirm();
      } else if (event.keyCode === 27) {
        this.call();
      }
      // this.$parent.del();
    },
    // 搜索
    seek () {
      this.search = this.search.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
      this.queryPage("1", this.search);
      //  this.search = ""
    },
    // 跳转页
    handleCurrentChange (val) {
      this.queryPage(val, this.search);
      sessionStorage.setItem("myCurrentPage", val); // 将页码存sessionStorage，刷新还在当前页
    },
    // 获取表格
    queryPage (page, search) {
      var that = this;
      var params = {
        page,
        rows: "20",
        filter: {
          trans_lib_id: that.rowId,
          source_sent: search,
          target_sent: search,
          company_code: localStorage.myCompanyCode,
          platformType: this.$platformType
        },
        sort: {
          create_time: "desc"
        }
      };
      this.catReq1Service(this.checkPageUrl, params).then(function (response) {
        if (!response.success) {
          return;
        }
        if (response.list == null) {
          response.list = [];
        }
        that.totalRows = response.totalRows;
        that.tableData = response.list;
        that.loading = false;
        if (that.currentPage > 1 && that.tableData.length < 1) {
          sessionStorage.myCurrentPage = sessionStorage.myCurrentPage - 1;
          that.currentPage - 1;
          that.queryPage(sessionStorage.myCurrentPage, that.search);
        }
      });
    },
    // 弹窗确定
    confirm () {
      var that = this;
      if (!that.isDel) {
        this.topText = this.topText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
        this.botText = this.botText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
        if (that.topText === "") {
          that.$message.closeAll();
          that.$message({
            message: "请填写原文",
            type: "warning"
          });
          return;
        }
        if (that.botText === "") {
          that.$message.closeAll();
          that.$message({
            message: "请填写译文",
            type: "warning"
          });
          return;
        }
        // 添加
        // var obj = {};
        // obj.sourceSent = that.topText;
        // obj.targetSent = that.botText;
        // that.tableData.unshift(obj);
        var params = {
          sourceSent: that.topText,
          targetSent: that.botText,
          transLibId: that.rowId,
        };
        this.catReq1Service(that.checkAddUrl, params).then(function (response) {
          if (!response.success) {
            return;
          }
          that.isShow = false;
          that.topText = "";
          that.botText = "";
          sessionStorage.setItem("myCurrentPage", 1);
          that.currentPage = 1;
          that.search = ""
          that.queryPage(1);
        });
      } else {
        that.toggleSelection(); //删除
      }
    },
    // 弹窗取消
    call () {
      var that = this;
      that.isShow = false;
      that.topText = "";
      that.botText = "";
    },
    // 添加弹窗
    getMesBox () {
      var that = this;
      that.isShow = true;
      that.isDel = false;
      // debugger
      if (this.checkTxt === "记忆库") {
        that.downloadBoxTit = "添加记忆库";
      } else {
        that.downloadBoxTit = "添加术语库";
      }
    },
    // 添加弹窗关闭
    getMesShow () {
      this.isShow = false;
    },
    // qq(row) {
    //   console.log(row);

    //   if (row.te) {
    //     return "butClass";
    //   }
    // },
    // 返回上一页
    backtrack () {
      this.$router.go(-1);
    },
    // 验证是否修改
    changeVerify (e) {
      //console.log(e.target.innerHTML)
      this.beforeDate = e.target.innerHTML;
      this.updateText = e.target.innerText;
    },
    // 修改
    changeUpdate (index, row, e, type) {
      let that = this
      //console.log(e.target.innerText);
      let data = e.target.innerText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
      row.te = true;
      let reg = /(<span>)|(<\/span>)/g;
      let sourceSent = row.sourceSent
      let targetSent = row.targetSent
      if (this.updateText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "") === data) {
        return
      }
      var params = {
        id: row.id,
        [!type ? "sourceSent" : "targetSent"]: data,
      };

      this.catReq1Service(this.checkUpdate, params).then(function (response) {
         if (response.resultCode == 1) {
          that.$message({
            message: "修改成功!",
            type: "success"
          })
        }else{
          e.target.innerHTML = that.beforeDate
        }
      });

    },
    // 保存
    qwe (row) {
      // console.log(row);
    },
    // 删除弹窗
    toggleBox () {
      if (this.multipleSelection.length < 1) {
        this.$message.closeAll();
        this.$message({
          message: "请选择要删除的数据",
          type: "warning"
        });
        return;
      }
      var that = this;
      that.downloadBoxTit = "友情提示";
      that.isShow = true;
      that.isDel = true;
    },
    //  删除
    toggleSelection () {
      //   if (rows) {
      //     rows.forEach(row => {
      //       this.$refs.multipleTable.toggleRowSelection(row);
      //     });
      //   } else {
      //     this.$refs.multipleTable.clearSelection();
      //   }
      var that = this;
      var params = {
        idList: this.multipleSelection,
      };
      this.catReq1Service(this.checkDelUrl, params).then(function (response) {
        if (!response.success) {
          return;
        }
        that.isShow = false;
        that.sentCount = that.sentCount - that.multipleSelection.length;
        that.queryPage(that.currentPage, that.search);
      });
    },
    handleSelectionChange (val) {
      // 选中的元素
      // console.log(val, "/////////////");
      var arr = [];
      val.forEach(item => {
        arr.push(item.id);
      });
      this.multipleSelection = arr;
    }
  }
};
</script>
<style lang="less" scoped>
.checkTab {
  .returnBtn {
    width: 48px;
    height: 30px;
    line-height: 30px;
    background: #02A4FD;
    color: #fff;
    font-size: 18px;
  }
  // 添加弹窗
  .hide {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 1);
    opacity: 0.7;
    z-index: 888;
  }
  .downloadBox {
    // width: 826px;
    // height: 534px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(76, 76, 76, 0.8);
    border-radius: 10px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    opacity: 1;
    h5 {
      height: 48px;
      line-height: 48px;
      border-radius: 10px 10px 0px 0px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      position: relative;
      border-bottom: 1px solid #dfe4e8;
      width: 90%;
      margin: 0 auto;
      span {
        position: absolute;
        right: 10px;
        top: 2px;
        img {
          cursor: pointer;
          -webkit-transition: -webkit-transform 0.6s ease-out;
          -moz-transition: -moz-transform 0.6s ease-out;
          transition: transform 0.6s ease-out;
        }
        img:hover {
          -webkit-transform: rotate(180deg);
          -moz-transform: rotate(180deg);
          transform: rotate(180deg);
        }
      }
    }
    .mainText {
      margin: 50px 0px;
      font-size: 16px;
      width: 450px;
    }
    .main {
      margin: 50px 0;
      width: 826px;
      div {
        // margin: 0px auto;
        // width: 1000px;
        display: flex;
        justify-content: center;
        // align-items: center;
        margin-bottom: 28px;
        .txt {
          resize: none;
          width: 643px;
          height: 130px;
          background: rgba(249, 249, 249, 1);
          border: 1px solid rgba(221, 221, 221, 1);
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: rgba(69, 69, 69, 1);
        }
        .txt:focus {
          outline: none;
          border: 1px solid #454545;
        }
        p {
          float: left;
          width: 50px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: rgba(69, 69, 69, 1);
        }
      }
    }
    .but {
      padding-bottom: 30px;
      margin: 0 80px;
      button:nth-child(2) {
        margin-left: 30px;
      }
    }

    // p {
    //   position: absolute;
    //   bottom: 29px;
    //   left: 30px;
    //   font-size: 14px;
    //   font-family: Microsoft YaHei;
    //   font-weight: 400;
    //   color: rgba(153, 153, 153, 1);
    // }
  }
  // 添加弹窗 结束
  header {
    display: flex;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
    margin-bottom: 15px;
    text-align: center;
    padding: 0 10px;
    position: relative;
    div {
      margin: 0 auto;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
    // span {
    //   // float: left;
    //   font-size: 18px;
    //   line-height: 30px;
    //   font-family: MicrosoftYaHei;
    //   font-weight: 400;
    //   color: rgba(69, 69, 69, 1);
    //   padding-left: 64px;
    // }
  }
  .main_box {
    height: 100%;
    textarea {
      vertical-align: middle;
      // text-align:center;
    }
    // width: 1660px;
    position: relative;
    // height: 783px;
    height: calc(100% - 45px);
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    // margin-top: 62px;
    padding: 0 20px;
    h3 {
      text-align: left;
      height: 20px;
      font-size: 18px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      padding-top: 20px;
      margin-left: 29px;
    }
    .topBox {
      margin-left: 29px;
      padding-top: 16px;
      margin-bottom: 7px;
      height: 40px;
      line-height: 38px;
      position: relative;
      input {
        float: right;
        width: 224px;
        height: 36px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(184, 196, 206, 1);
        border-radius: 2px 0px 0px 2px;
        padding: 0 10px;
        padding-right: 24px;
      }
      input:focus {
        outline: none;
        border: 1px solid #454545;
      }
      button {
        float: left;
        width: 80px;
        height: 34px;
        box-sizing: border-box;
        margin-right: 40px;
      }
      .search {
        position: absolute;
        right: 10px;
        top: 27px;
      }
      div {
        float: left;
        // margin-right: 20px;
        button {
          margin-left: 0px;
          margin-right: 0;
          font-size: 14px;
        }
        button:nth-child(2) {
          margin-left: 30px;
        }
      }
    }
    #notDate {
      // 暂无数据
      // margin-top: 80px;
      height: 100%;
      img {
        height: 50%;
        width: 50%;
      }
    }
    /deep/.el-table--border::after,
    .el-table--group::after {
      width: 0px;
    }
    // /deep/.el-table::before {
    //   background-color: transparent;
    // }
    /deep/.has-gutter {
      tr {
        th {
          border: 0px;
          border-bottom: 1px solid #ebeef5;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: center;
        }
      }
    }
    /deep/.el-table td,
    .el-table th {
      // 修改table行高
      padding: 0px !important;
      // height: 46px;
    }
    .el-table td,
    .el-table th {
      padding: 0px;
    }
    /deep/.el-table td:nth-child(1) {
      border-left: 1px solid #ebeef5;
    }
    /deep/.el-table td {
      text-align: center;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
    }
    /deep/.el-table td:nth-child(3) {
      text-align: left;
    }
    /deep/.el-table td:nth-child(4) {
      text-align: left;
    }
    /deep/.el-table--enable-row-hover .el-table__body tr tr tr:hover {
      box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5);
    }
    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
      // table 鼠标滑动效果
      background: #f5f7fa;
    }
    /deep/.el-table {
      border: 0px;
      //   width: 1620px;
      .cell {
        display: flex;
        justify-content: center;
        align-items: center;
        div {
          min-height: 36px;
          width: 100%;
          border: 0px;
          padding: 5px;
          // resize: none;
          background: transparent;
        }
        div:focus {
          //清除div获取焦点之后出现的边框
          outline: none;
        }
      }

      button {
        width: 60px;
        height: 28px;
        line-height: 28px;
        background: rgba(241, 241, 241, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        border-radius: 4px;
        border: 0px;
        color: rgba(153, 153, 153, 1);
      }
      .butClass {
        background: rgba(57, 139, 241, 1);
        color: rgba(255, 255, 255, 1);
        border: 0px;
      }
    }

    /* 页码样式开始 */
    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      // 页码点击效果
      // background: rgba(69, 69, 69, 1);
      color: rgba(255, 255, 255, 1);
      border: 0px;
    }
    /deep/.el-pager li {
      // 页码样式
      min-width: 30px;
      height: 30px;
      border: 1px solid rgba(187, 187, 187, 1);
      border-radius: 2px;
      background: transparent;
      line-height: 30px;
      font-size: 14px;
      font-weight: 400;
    }
    /deep/.el-pagination button {
      // 页码上下页样式
      width: 68px;
      height: 30px;
      border: 1px solid rgba(187, 187, 187, 1);
      border-radius: 2px;
      line-height: 30px;
      font-size: 14px;
      background: transparent;
      color: rgba(102, 102, 102, 1);
      font-weight: 400;
    }
    /deep/.el-pagination button:hover {
      border: 1px solid rgba(128, 128, 128, 1);
    }
    /deep/.el-pagination button:active {
      background: rgba(224, 237, 252, 1);
      border: 1px solid rgba(187, 187, 187, 1);
    }
    .page {
      position: absolute;
      bottom: 20px;
      right: 20px;
    }
    /* 页码样式结束 */
  }
  /deep/.el-table__row {
    td {
      .cell {
        white-space: pre-wrap;
        word-wrap: break-word;
        word-break: normal;
        word-break: break-all;
      }
    }
  }
}
</style>
<style lang="less">
.checkTab {
  .main_box {
    //  height:calc(100% - 52px);
    .el-table {
      // 高亮显示当前行的样式
      .el-table__body tr.current-row > td {
        // border-right: 1px solid #666666;
        border-bottom: 1px solid #4885F1;
        border-top: 1px solid #4885F1;
        // border: 1px solid #666666;
        background-color: #f5f7fa;
        // color: #fff;
      }
      .el-table__body tr.current-row > td:first-child {
        border-left: 1px solid #4885F1 !important;
      }
      height: calc(100% - 50px);
      .el-table__body-wrapper {
        overflow-y: auto;
        height: calc(100% - 48px);
      }
    }
  }
}
</style>